import dynamic from 'next/dynamic';
import { Fragment } from 'react';

import { EnterpriseBanner } from '@/components/atomic/atoms';
import {
  BecomePartner,
  FeaturedCategoriesWeb,
  TopBrandsWeb,
  TrendingServices,
  TrustedPartners
} from '@/components/atomic/molecules';
import {
  DefaultLayoutOrganism,
  EventsGlimpsesWebOrganism,
  HaflaBlogOrganism,
  HeaderOrganism,
  TrendingCollectionOrganism,
  WhyChooseHaflaOrganism
} from '@/components/atomic/organism';

const HowDoesItWork = dynamic(
  () => import('@/components/atomic/molecules/homePage/HowDoesItWork'),
  {
    ssr: false
  }
);

const isActive = false;

const WebHomeTemplate = ({
  bannerTranslation,
  blogPost,
  collections,
  parentCategories
}) => (
  <Fragment>
    <HeaderOrganism
      categories={parentCategories}
      homeScreen={true}
    />
    <DefaultLayoutOrganism
      paramData={{
        bannerTranslate: bannerTranslation,
        eventCategory: 'home',
        homeScreen: true,
        translate: bannerTranslation
      }}
    >
      <TopBrandsWeb />
      <TrendingServices />
      <FeaturedCategoriesWeb />
      <EnterpriseBanner />
      <TrustedPartners />
      <EventsGlimpsesWebOrganism />
      <BecomePartner />
      <TrendingCollectionOrganism {...{ collectionList: collections }} />
      <WhyChooseHaflaOrganism />
      {isActive && <HowDoesItWork />}
      <HaflaBlogOrganism posts={blogPost} />
    </DefaultLayoutOrganism>
  </Fragment>
);

export default WebHomeTemplate;
